<script setup>
import { ref, watch, inject } from 'vue';
import i18n from "@/i18n"
import fileActionCom from "../common/fileAction.vue";
const detailInfo = inject('detailInfo')
const tabList = inject('tabList')
const current_tab = inject('current_tab')
const otherInfo = ref([])
// const setType = (filename)=> {
//     // 获取文件类型
//     let fileType = filename.split('.').pop()
//     if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
//         return 'image'
//     }
//     return 'file'
// }
const filterImglist = (valList, imageInfo) => {
    if (valList && valList.length && Object.keys(valList).length) {
        const fileList = valList.map(item => {
            return imageInfo[item]
        })
        return fileList
    }
    return []
}
watch(detailInfo, (val) => {
    //设置自定义字段list
    // console.log(val);
    const { extra_info } = val
    // console.log(extra_info);
    const etrList = extra_info && extra_info.children &&  extra_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    // console.log(extra_info.children)
    if (etrList.length) {
        otherInfo.value = etrList.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                type: item.extra.myKey,
                fieldList: item.children ? item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: ele.value,
                    }
                }) : [],
                value: item.value,
                imageList: [],
            }
            return m
        })
        otherInfo.value.forEach(item => {
            if (item.value && item.value.length) {
                // let ids = item.value.join(',')
                // getFileUrl({ attachments: ids }).then(res=> {
                //     res.payload.map(item=> {
                //         item.filename  = item.name,
                //         item.type = setType(item.filename)
                //     })
                //     item.imageList = res.payload
                // })
                item.imageList = filterImglist(item.value, val.imageInfo)
            }
        })
        // console.log(otherInfo.value);
        tabList.value[tabList.value.length -1].show = true
    } else {
        tabList.value[tabList.value.length -1].show = false;
        current_tab.value = 0
    }
}, { deep: true })

// // 监听数据 如果数据长度为0  则不显示tab
// watch(() => otherInfo.value.length, (val) => {
//     // console.log(val);
//     if (val == 0) {
//         // console.log(tabList);
//         tabList.value[tabList.value.length -1].show = false;
//         current_tab.value = 0
//     }
// }, { immediate: true })

</script>
<template>
    <!-- style="border: 1px solid #E9EBEC;" -->
    <div class="otherInfo p-2">
        <div v-if="otherInfo.length">
            <div v-for="(item, k) in otherInfo" :key="k">
                <div class="title py-4" style="border-bottom: 1px solid #E9EBEC; ">{{ i18n.global.locale == 'en' ?item.name_en: item.name}}</div>
                <template v-if="item.type == '文本项'">
                    <div style="" class="p-2" v-if="item.fieldList.length">
                        <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
                            style="border-bottom: 1px solid #E9EBEC; ">
                            <div style="font-weight: bold; flex: 2; max-width: 200px;">
                                {{ i18n.global.locale == 'en' ? aa.name_en : aa.name }}
                            </div>
                            <div style=" flex: 6;">
                                {{ aa.value ? aa.value : '-' }}{{ aa.value && aa.unit ? `${aa.unit}` : '' }}
                            </div>
                        </div>
                    </div>
                    <Empty v-else></Empty>
                </template>
                <template v-else>
                    <template v-if="item.fieldList.length || item.imageList.length">
                        <div style="color:#212529" class="row d-flex justify-content-start px-3"
                            v-if="item.fieldList.length">
                            <!-- <div class="col-6 my-1 d-flex align-items-center" v-for="(item, k) in item.fieldList"
                                :key="k">
                                <div class="mx-2"
                                    style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                </div>
                                <span>{{ item.name }} : {{ item.value ?  item.value: '-' }}{{ item.value && item.unit ? `${item.unit}` : '' }}</span>
                            </div> -->
                            <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
                                style="border-bottom: 1px solid #E9EBEC; ">
                                <div style="font-weight: bold; flex: 2; max-width: 200px;">
                                    {{ i18n.global.locale == 'en' ? aa.name_en : aa.name }}
                                </div>
                                <div style=" flex: 6;">
                                    {{ aa.value ? aa.value : '-' }}{{ aa.value && aa.unit ? `${aa.unit}` : '' }}
                                </div>
                            </div>
                        </div>
                        <div class="qualityInspectionReport py-4 my-2" v-if="item.imageList.length">
                            <div class="d-flex justify-content-start align-items-center ">
                                <div class="d-flex justify-content-center align-items-center mx-2 file-view"
                                    v-for="(image, kk) in item.imageList" :key="kk"
                                    style="width: 120px; height: 120px; border-radius: 4px; position: relative;">
                                    <i v-if="image.type == 'file'" class="ri-file-text-line"
                                        style="font-size: 110px;color:#0AB39C"></i>
                                    <img v-else :src="image.url" alt="" style="object-fit: fill;max-height: 117px;"
                                        @click="handleImgPreview(image.url)" class="cursor-pointer" />
                                    <!-- 文件操作按钮 -->
                                    <fileActionCom :image="image" v-if="image.showAction || true" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <Empty v-else></Empty>
                </template>
            </div>
        </div>
        <Empty v-else></Empty>
    </div>
</template>
<style scoped></style>